import { RACQAddressResult } from '@/interfaces';
import { CreatePartyRequest } from '@/interfaces/entities/create-party.interface';
import { CreateQuoteRequest } from '@/interfaces/entities/create-quote.interface';
import { VehicleDetail } from '@/interfaces/entities/vehicle-eligibility.interface';

export const mapToCreatePartyRequestForBusiness = (
  abn: string,
  acn: string | null,
  businessName: string,
  emailAddress: string,
  preferredPhoneNumber: string,
  membershipType: string,
  homeAddress: RACQAddressResult,
  postalAddress: RACQAddressResult
): CreatePartyRequest => {
  return {
    businessDetails: {
      abn: abn,
      acn: acn,
      businessName: businessName,
    },
    emailAddress,
    preferredPhoneNumber,
    membershipType,
    homeAddress: {
      dpid: homeAddress?.dpid,
      unit: homeAddress?.unitNumber,
      streetNumber: homeAddress?.streetNumber,
      street: homeAddress?.street,
      suburb: homeAddress?.suburb,
      postcode: homeAddress?.postcode,
      state: homeAddress?.state,
      country: homeAddress?.countryISO,
    },
    postalAddress: {
      postalDeliveryType: postalAddress?.postalDeliveryType,
      dpid: postalAddress?.dpid,
      unit: postalAddress?.unitNumber,
      streetNumber: postalAddress?.streetNumber,
      street: postalAddress?.street,
      suburb: postalAddress?.suburb,
      postcode: postalAddress?.postcode,
      state: postalAddress?.state,
      country: postalAddress?.countryISO,
    },
  } as CreatePartyRequest;
};

export const mapToCreatePartyRequestForPersonal = (
  title: string,
  firstName: string,
  lastName: string,
  dateOfBirth: string,
  emailAddress: string,
  preferredPhoneNumber: string,
  membershipType: string,
  homeAddress: RACQAddressResult,
  postalAddress: RACQAddressResult
): CreatePartyRequest => {
  return {
    title,
    firstName,
    lastName,
    dateOfBirth,
    emailAddress,
    preferredPhoneNumber,
    membershipType,
    homeAddress: {
      dpid: homeAddress?.dpid,
      unit: homeAddress?.unitNumber,
      buildingLevel: homeAddress?.buildingLevel,
      streetNumber: homeAddress?.streetNumber,
      street: homeAddress?.street,
      suburb: homeAddress?.suburb,
      postcode: homeAddress?.postcode,
      state: homeAddress?.state,
      country: homeAddress?.countryISO,
    },
    postalAddress: {
      postalDeliveryType: postalAddress?.postalDeliveryType,
      dpid: postalAddress?.dpid,
      unit: postalAddress?.unitNumber,
      buildingLevel: postalAddress?.buildingLevel,
      streetNumber: postalAddress?.streetNumber,
      street: postalAddress?.street,
      suburb: postalAddress?.suburb,
      postcode: postalAddress?.postcode,
      state: postalAddress?.state,
      country: postalAddress?.countryISO,
    },
  } as CreatePartyRequest;
};

export const mapToCreateQuoteRequest = (
  vehicleDetail: VehicleDetail | null | undefined,
  productCode: string,
  productName: string,
  apttusId: string,
  vehicleRegistrationNumber: string,
  vehicleManufacturingYear: number,
  vehicleStateCode: string | undefined,
  vehicleColour: string,
  vehicleMake: string,
  vehicleModel: string,
  surchargeLevel: string | null
): CreateQuoteRequest => {
  return {
    productCode: productCode ?? '',
    productName,
    apttusId: apttusId ?? '',
    surchargeLevel,
    vehicle: {
      nvic: vehicleDetail?.nvic,
      kerbWeight: vehicleDetail?.kerbWeight,
      kerbWeightUnit: vehicleDetail?.kerbWeightUnit,
      length: vehicleDetail?.length,
      lengthUnit: vehicleDetail?.lengthUnit,
      weight: vehicleDetail?.weight,
      weightUnit: vehicleDetail?.weightUnit,
      loadCapacity: vehicleDetail?.loadCapacity,
      loadCapacityUnit: vehicleDetail?.loadCapacityUnit,
      registrationNumber: vehicleRegistrationNumber,
      manufacturingYear: vehicleManufacturingYear,
      stateCode: vehicleStateCode,
      body: {
        code: vehicleDetail?.body.code,
        description: vehicleDetail?.body.description,
        colour: vehicleColour,
      },
      make: {
        code: vehicleDetail?.make.code,
        description: vehicleMake,
      },
      model: {
        code: vehicleDetail?.model.code,
        description: vehicleModel,
      },
      variant: {
        code: vehicleDetail?.variant.code,
        description: vehicleDetail?.variant.description,
      },
      option: {
        transmission: vehicleDetail?.option.transmission,
      },
      fuelType: {
        description: vehicleDetail?.fuelType.code,
      },
    },
  } as CreateQuoteRequest;
};
